import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.5859 20.0356L18.5859 13.0356L2 13.0356L2 11.0356L18.5859 11.0356L11.5859 4.03558L13 2.62152L21.707 11.3286C22.0975 11.7191 22.0975 12.3521 21.707 12.7426L13 21.4496L11.5859 20.0356Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowRight);
const Memo = memo(ForwardRef);
export default Memo;
